module.exports = __webpack_public_path__ + "media/images/writer/monitor/bg-about-9803a24501ce40d026351b48073013d7.png";